/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class StandaloneTestingRoute extends Route {
  @service declare realTimeEventService: $TSFixMe;

  // This runs when entering any route under /testing
  activate() {
    this.realTimeEventService.subscribeTopics(['fin-playground']);
  }

  // This runs when leaving the /testing hierarchy completely
  deactivate() {
    this.realTimeEventService.unsubscribeTopics(['fin-playground']);
  }
}
